import { useLocation, Link, NavLink, useParams, useSearchParams } from "react-router-dom";
import { EntityType, RoutePath } from "shared/constants";
import { v4 as uuid } from "uuid";
import "components/Breadcrumb/breadcrumbStyle.css";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

interface IBreadcrumbToken {
    label: string,
    link?: RoutePath | string,
    goBack?: boolean
}

const Breadcrumb = (): JSX.Element => {

    const {t} = useTranslation(['contract', 'b2b', 'preBilling', 'app']);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
        setIsMobile(window.innerWidth <= 1023); // Cambia la larghezza se necessario
        };
        checkScreenSize(); // Controllo iniziale
        window.addEventListener("resize", checkScreenSize);
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);
    let location = useLocation();
    const { id, codeIup } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const entityType: EntityType | null = (searchParams as URLSearchParams).get("entityType") as EntityType;
    const entityId: string | null = (searchParams as URLSearchParams).get("entityId");
    const transporterId: string | null = (searchParams as URLSearchParams).get("transporterId");
    const calendarDraft: string | null = searchParams.get("draft");

    const getContentTokens = () => {
        const pathnames = location.pathname.split('/').filter(x => x);
        let tokens: IBreadcrumbToken[] = [];
        const prefix: string = "/" + pathnames.slice(0, 2).join("/");
        switch (prefix) {
            case RoutePath.DASHBOARD:
                tokens.push({label:t('sideBar.firstLevelButtons.0', {ns:['app']})});//"Dashboard"
                break;
            case RoutePath.CONTRACTS_CUSTOMER_INFO:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) }); //"Gestione contratti"
                //"Informazioni anagrafiche"
                tokens.push({ label: t('customer.customerList.title', {ns:['contract']}), link: id ? RoutePath.CONTRACTS_CUSTOMER_INFO : undefined });
                if (id) {
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}) });//"Dettagli"
                }
                break;
            case RoutePath.CONTRACTS_NEW_CUSTOMER:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                //"Informazioni anagrafiche"
                tokens.push({ label: t('customer.customerList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_CUSTOMER_INFO });
                tokens.push({ label: t('customer.customerForm.pageHeaders.new.0', {ns:['contract']}) });//"Inserisci cliente"
                break;
            case RoutePath.CONTRACTS_EDIT_CUSTOMER:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('customer.customerList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_CUSTOMER_INFO });//"Informazioni anagrafiche"
                tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_CUSTOMER_INFO + "/" + id });//"Dettagli"
                tokens.push({ label: t('customer.customerForm.pageHeaders.edit.0', {ns:['contract']}) });//"Modifica cliente"
                break;
            case RoutePath.CONTRACTS_CONTRACT_INFO:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                //"Informazioni contrattuali"
                tokens.push({ label: t('contract.contractList.title', {ns:['contract']}), link: id ? RoutePath.CONTRACTS_CONTRACT_INFO : undefined });
                if (id) {
                    //"Dettagli"
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}) });
                }
                break;
            case RoutePath.CONTRACTS_NEW_CONTRACT:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                //"Informazioni contrattuali"
                tokens.push({ label: t('contract.contractList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_CONTRACT_INFO });
                tokens.push({ label: t('contract.contractForm.pageHeaders.new.1', {ns:['contract']}) });//"Inserisci contrattto"
                break;
            case RoutePath.CONTRACTS_EDIT_CONTRACT:
            case RoutePath.CONTRACTS_EDIT_DOCUMENT:
                tokens.push({ label:  t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti" 
                if (entityType && entityType === EntityType.DRIVER) {
                    tokens.push({ label: t('drivers.driverList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_DRIVER_INFO });//"Flotta autisti"
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_DRIVER_INFO + "/" + entityId });//"Dettagli"
                } else if (entityType && entityType === EntityType.TRANSPORTER) {
                    tokens.push({ label: t('transporter.transporterList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_TRANSPORTATORS_INFO });//"Trasportatori"
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_TRANSPORTATORS_INFO + "/" + entityId });//"Dettagli"
                } else if (entityType && entityType === EntityType.VEHICLE) {
                    tokens.push({ label: t('vehicle.vehicleList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_VEHICLE_INFO });//"Flotta automezzi"
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_VEHICLE_INFO + "/" + entityId });//"Dettagli"
                } else if (entityType && entityType === EntityType.TRANSPORTERDELEGATION) {
                    tokens.push({ label: t('transporter.transporterList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_TRANSPORTATORS_INFO });//"Trasportatori"
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_TRANSPORTATORS_INFO + "/" + transporterId });//"Dettagli"
                }else {
                    //Informazioni contrattuali
                    tokens.push({ label: t('contract.contractList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_CONTRACT_INFO });
                    //"Dettagli"
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_CONTRACT_INFO + "/" + (entityId ? entityId : id) });
                }

                if (entityType && entityType === EntityType.CONTRACT) {
                    tokens.push({ label: t('contract.documentEdit.title', {ns:'contract'}) });//"Modifica documentazione contrattuale"
                } if (entityType && entityType === EntityType.DRIVER) {
                    tokens.push({ label: t('breadcrumb.editDocument.driver', {ns:['app']}) });//"Modifica documento autista"
                } if (entityType && entityType === EntityType.TRANSPORTER) {
                    tokens.push({ label: t('breadcrumb.editDocument.transporter', {ns:['app']}) });//"Modifica documento trasportatore"
                } else if (entityType && entityType === EntityType.VEHICLE) {
                    tokens.push({ label: t('breadcrumb.editDocument.vehicle', {ns:['app']}) });//"Modifica documento componente"
                } else if (!entityType) {
                    tokens.push({ label: t('contract.contractForm.pageHeaders.edit.1', {ns:['contract']}) });//Modifica contratto
                }
                break;
            case RoutePath.CONTRACTS_DRIVER_INFO:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti" 
                //"Flotta autisti"
                tokens.push({ label: t('drivers.driverList.title', {ns:['contract']}), link: id ? RoutePath.CONTRACTS_DRIVER_INFO : undefined })
                if (id) {
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}) });//"Dettagli"
                }
                break;
            case RoutePath.CONTRACTS_NEW_DRIVER:
                tokens.push({ label:  t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('drivers.driverList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_DRIVER_INFO });//"Flotta autisti"
                tokens.push({ label: t('drivers.driverForm.pageHeaders.new.0', {ns:['contract']}) });//"Inserisci autista" 
                break;
            case RoutePath.CONTRACTS_EDIT_DRIVER:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('drivers.driverList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_DRIVER_INFO });//"Flotta autisti"
                tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_DRIVER_INFO + "/" + id });//"Dettagli"
                tokens.push({ label: t('drivers.driverForm.pageHeaders.edit.0', {ns:['contract']}) });//"Modifica autista"
                break;
            case RoutePath.CONTRACTS_TRANSPORTATORS_INFO:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                //"Trasportatori"
                tokens.push({ label: t('transporter.transporterList.title', {ns:['contract']}), link: id ? RoutePath.CONTRACTS_TRANSPORTATORS_INFO : undefined });//"Trasportatori"
                if (id) {
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}) });//"Dettagli"
                }
                break;
            case RoutePath.CONTRACTS_NEW_TRANSPORT:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('transporter.transporterList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_TRANSPORTATORS_INFO });//"Trasportatori"
                tokens.push({ label: t('transporter.transporterForm.pageHeaders.new.0', {ns:['contract']}) });//"Inserisci trasportatore"
                break;
            case RoutePath.CONTRACTS_EDIT_TRANSPORT:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('transporter.transporterList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_TRANSPORTATORS_INFO });//"Trasportatori"
                tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_TRANSPORTATORS_INFO + "/" + id });//"Dettagli"
                tokens.push({ label: t('transporter.transporterForm.pageHeaders.edit.0', {ns:['contract']}) });//"Modifica trasportatore"
                break;
            case RoutePath.CONTRACTS_NEW_DELEGATION:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('customer.customerList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_CUSTOMER_INFO });//"Informazioni anagrafiche"
                tokens.push({ label: t('customer.customerForm.pageHeaders.edit.2', {ns:['contract']}) });
                break;
            case RoutePath.CONTRACTS_VEHICLE_INFO:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('vehicle.vehicleList.title', {ns:['contract']}), link: id ? RoutePath.CONTRACTS_VEHICLE_INFO : undefined });//"Flotta automezzi"
                break;
            case RoutePath.CONTRACTS_NEW_VEHICLE:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('vehicle.vehicleList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_VEHICLE_INFO });//"Flotta automezzi"
                tokens.push({ label: t('vehicle.vehicleForm.pageHeaders.new.1') });//"Inserisci componente"
                break;
            case RoutePath.CONTRACTS_EDIT_VEHICLE:
                tokens.push({ label: t('sideBar.firstLevelButtons.1.label', {ns:['app']}) });//"Gestione contratti"
                tokens.push({ label: t('vehicle.vehicleList.title', {ns:['contract']}), link: RoutePath.CONTRACTS_VEHICLE_INFO });//"Flotta automezzi"
                tokens.push({ label: t('breadcrumb.details', {ns:['app']}), link: RoutePath.CONTRACTS_VEHICLE_INFO + "/" + id });//"Dettagli"
                tokens.push({ label: t('vehicle.vehicleForm.pageHeaders.edit.1') });//"Modifica componente"
                break;
            case RoutePath.B2B_BOOKINGS_INFO:
                tokens.push({ label: t('sideBar.firstLevelButtons.2.label', {ns:['app']}) });//"Portale B2B"
                tokens.push({ label: t('booking.bookingList.title', {ns:['b2b']}), link: codeIup ? RoutePath.B2B_BOOKINGS_INFO : undefined });//"Prenotazioni"
                if (codeIup) {
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}) });//"Dettagli"
                }
                break;
            case RoutePath.B2B_CHECKLIST:
                tokens.push({ label: t('sideBar.firstLevelButtons.2.label', {ns:['app']}) });//"Portale B2B"
                tokens.push({ label: t('booking.bookingList.title', {ns:['b2b']}), link: RoutePath.B2B_BOOKINGS_INFO });//"Prenotazioni"
                //"Dettagli"
                tokens.push({ label: t('breadcrumb.details', {ns:['app']}), goBack:true });//RoutePath.B2B_BOOKINGS_INFO + "/" + codeIup });
                tokens.push({ label: "Checklist"});//"Checklist"
                break;
            case RoutePath.B2B_CLONE_RESERVATION:
                tokens.push({ label: t('sideBar.firstLevelButtons.2.label', {ns:['app']}) });//"Portale B2B"
                tokens.push({ label: t('booking.bookingList.title', {ns:['b2b']}), link: RoutePath.B2B_BOOKINGS_INFO });//"Prenotazioni"
                tokens.push({ label: t('breadcrumb.details', {ns:['app']}), goBack:true });//"Dettagli"
                tokens.push({ label: t("booking.cloneSlot.5", {ns:['b2b']})});//"Clona prenotazione"
                break;
            case RoutePath.B2B_CALENDAR:
                tokens.push({ label: t('sideBar.firstLevelButtons.2.label', {ns:['app']}) });//"Portale B2B"
                tokens.push({label:calendarDraft==="true"?t('calendar.title.1', {ns:['b2b']}):t('calendar.title.0', {ns:['b2b']})});//"Calendario provvisorio"||"Calendario"
                break;
            case RoutePath.B2B_CALENDAR_SETTING:
                tokens.push({ label: t('sideBar.firstLevelButtons.2.label', {ns:['app']}) });//"Portale B2B"
                tokens.push({ label: t('calendarSettingsForm.title', {ns:['b2b']}) });//Configurazione
                break;
            case RoutePath.SETTINGS_SLOT_PARAMETERS:
                tokens.push({ label: t('sideBar.firstLevelButtons.4.label', {ns:['app']}) });//"Impostazioni"
                tokens.push({ label: t('settings.slotParameters.title', {ns:['contract']}) });//"Parametri slot"
                break;
            case RoutePath.SETTINGS_FREEZING_SHORT:
                tokens.push({ label: t('sideBar.firstLevelButtons.4.label', {ns:['app']}) });//"Impostazioni"
                tokens.push({ label: t('settings.slotFreezing.title', {ns:['contract']}) });//"Freezing date - Short term" 
                break;
            case RoutePath.SETTINGS_SHIPPER_PARAMETERS:
                tokens.push({ label: t('sideBar.firstLevelButtons.4.label', {ns:['app']}) });//"Impostazioni"
                tokens.push({ label: t('settings.shipperParameters.title1', {ns:['contract']}), link: RoutePath.SETTINGS_SHIPPER_PARAMETERS });//"Shipper Parameters"
                break;
            case RoutePath.SETTINGS_NEW_SHIPPER:
                tokens.push({ label: t('sideBar.firstLevelButtons.4.label', {ns:['app']}) });//"Impostazioni"
                tokens.push({ label: t('settings.shipperParameters.title1', {ns:['contract']}), link: RoutePath.SETTINGS_SHIPPER_PARAMETERS });//"Shipper Parameters"
                tokens.push({ label: t('settings.shipperParameters.title2', {ns:['contract']})});//"Shipper Parameters"
                break;
            case RoutePath.PRE_BILLING_INFO:
                tokens.push({label:"Pre-billing"});
                tokens.push({label:"Report", link: codeIup ? RoutePath.PRE_BILLING_INFO : undefined });
                if (codeIup) {
                    tokens.push({ label: t('breadcrumb.details', {ns:['app']}) });//"Dettagli"
                }
                break;
            case RoutePath.PRE_BILLING_EDIT:
                tokens.push({label:"Pre-billing"});
                tokens.push({label:"Report", link:RoutePath.PRE_BILLING_INFO});
                tokens.push({ label: t('breadcrumb.details', {ns:['app']}), goBack:true });//Dettagli
                tokens.push({ label:t('preBilling.preBillingForm.pageHeaders.edit.0', {ns:['preBilling']}) });//Modifica dettagli
                break;
            case RoutePath.CONGUAGLIO:
                tokens.push({label:"Pre-billing"});                
                tokens.push({ label:t('preBilling.conguaglio.pageHeaders.0', {ns:['preBilling']}) });
                break;
            default:
                break;
        }
        return tokens;
    }




    const formatTokens = () => {
        return getContentTokens().map((token: IBreadcrumbToken) => {
            return (
                <li key={uuid()}>
                    {token.link 
                        ? <Link to={token.link}>{token.label}</Link>
                        : token.goBack
                        ? <NavLink to={-1 as any}>{token.label}</NavLink> 
                        :<span>{token.label}</span>
                    }
                </li>
            )
        })
    }

    const breadcrumbItems = formatTokens();

    return (
        <ol id="breadcrumb" style={{marginLeft:isMobile?'92px':'42px'}}>
            {breadcrumbItems}
        </ol>
    )


}

export default Breadcrumb;